import React, { useState, createContext } from 'react'

interface TabberContextData {
  currentTab: string
  setCurrentTab: (tab: string) => void
  subTab: string
  setSubTab: (tab: string) => void
}

export const TabberContext = createContext({} as TabberContextData)

export const TabberProvider: React.FC<{}> = ({ children }) => {
  const [currentTab, setCurrentTab] = useState('Tests')
  const [subTab, setSubTab] = useState('QuestionnaireHistory')

  return (
    <TabberContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        subTab,
        setSubTab,
      }}
    >
      {children}
    </TabberContext.Provider>
  )
}

export default TabberProvider
